import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { AuthenticationService, SnackbarService } from '../standard';

@Injectable()
export class AuthGuard  {

	constructor(private authService: AuthenticationService,
	            private snackbarService: SnackbarService,
	            private router: Router) {
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Promise<boolean> {

		return this.authService.isLoggedIn()
			.then(
				success => {
					return true;
				})
			.catch(err => {
				this.router.navigate(['/']);
				return false;
			});
	}

	canActivateChild(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Promise<boolean> {
		return this.canActivate(next, state);
	}
}
